export const introduce = {
  text: `### 使用方法
  + 长期持有者抛售指标走高，长期持有者回到HODL行为指标走低。
  
  ### 指标原理
  + 持有期*数量通常被称为股份（stake），我们将Liveliness定义为使用股份(stakes used)和所有股份总和(all stakes existed)的比率
  + Liveliness可以定义为被摧毁的比特币天数之和（Bitcoin Days Destroyed）与所有比特币天数之和之比`,
  height: 1350,
};
